import { JSX } from 'preact'
import { BlockType, TBlockProps } from '@gsc/types'
import classnames from 'classnames'
import { previewProps } from '../../preview'
import { useFormContext } from '../Form/useFormContext'
import { useComponentStyle } from '../Style'
import { Text } from './Text'
import { BlockTree } from './BlockTree'

export function FormField({ label, element, ...props }: TBlockProps<BlockType.FormField>): JSX.Element {
  const { getValidity } = useFormContext()
  const valid = getValidity(element.name)
  const { classes } = useComponentStyle('field', props)
  const className = classnames(classes, { valid, invalid: !valid, hidden: element?.type === BlockType.Hidden })

  return (
    <div className={className} {...previewProps(BlockType.FormField, props.id)}>
      {label && <Text className="field-title" {...label} />}
      <BlockTree root={element} />
    </div>
  )
}
